"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { FxVariables } from "~/lib/flags/definitions";

const PrecomputedFlagsContext = createContext<FxVariables>({});

export function PrecomputedFlagsProvider({ flags, children }: { flags: FxVariables; children: ReactNode }) {
    return <PrecomputedFlagsContext.Provider value={flags}>{children}</PrecomputedFlagsContext.Provider>;
}

export const usePrecomputedFlags = () => useContext(PrecomputedFlagsContext);
